<script setup>
const { y } = useWindowScroll();

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
</script>

<template>
  <VScaleTransition
    class="scroll-to-top d-print-none"
    style="transform-origin: center"
  >
    <VBtn
      v-show="y > 200"
      class="btn-scroll-to-top"
      density="comfortable"
      icon
      @click="scrollToTop"
    >
      <VIcon icon="tabler-arrow-up" size="22" />
    </VBtn>
  </VScaleTransition>
</template>

<style lang="scss">
.scroll-to-top {
  position: fixed !important;

  // To keep button on top of v-layout. E.g. Email app
  z-index: 999;
  inset-block-end: 5%;
  inset-inline-end: 25px;
}
</style>
